module.exports = __webpack_public_path__ + "57c13e0ad39d1dd29bb000e0e18b6aa2.pdf";